module.exports = __webpack_public_path__ + "static/media/md-quote.61276847.svg";